const mainCoverCountries: [string, string] = ["Worldwide", "Morocco"];

export { mainCoverCountries };
